import {
  EchoCommand,
  EchoCommandOutput,
  SubmitOnboardingRequestCommand,
  SubmitOnboardingRequestOutput,
  SubmitOnboardingRequestInput,
  GetOnboardedTeamsCommand,
  GetOnboardedTeamsCommandOutput,
  DependencySentinelClient,
  GetTeamPackageListCommandInput,
  GetTeamPackageListCommandOutput,
  GetTeamPackageListCommand,
  GetPackageDependencyListCommand,
  GetPackageDependencyListCommandInput,
  GetPackageDependencyListCommandOutput,
  SubmitPackageDryRunUpgradesCommand,
  SubmitPackageDryRunUpgradesCommandOutput,
  GetPackageDryRunUpgradesResultCommand,
  GetPackageDryRunUpgradesResultCommandOutput,
} from "@amzn/dependencysentinel";
import { logging } from "src/core/util/log";
import { UserIdentity } from "src/core/auth/types";
interface BaseControllerProps {
  userIdentity: UserIdentity;
  sentinelClient: DependencySentinelClient;
}
export abstract class BaseController {
  client: DependencySentinelClient;
  userIdentity: UserIdentity;
  constructor(props: BaseControllerProps) {
    logging.log("Initializing BaseController");
    logging.log(JSON.stringify(props));
    this.userIdentity = props.userIdentity;
    this.client = props.sentinelClient;
    logging.log("initialized SentinelClient");
  }
  /**
   *
   * Delegate the request to activity function
   * @private
   * @template T
   * @param {(credentials: any) => any} command
   * @return {*}  {Promise<T>}
   * @memberof SwiftController
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected async _send<T>(command: (credentials: any) => any): Promise<T> {
    const request = command(this.userIdentity);
    const response = this.client.send(request);
    return response as T;
  }
}
export class SentinelController extends BaseController {
  /**
   * Echo function
   * @param {string} message
   * @return {*}
   * @memberof SentinelController
   */
  public async echo(message: string) {
    const response = await this._send<EchoCommandOutput>(
      () =>
        new EchoCommand({
          string: message,
        }),
    );
    return response;
  }
  public async submitOnboardingRequest(
    onboardingRequestInput: SubmitOnboardingRequestInput,
  ) {
    const response = await this._send<SubmitOnboardingRequestOutput>(
      () => new SubmitOnboardingRequestCommand(onboardingRequestInput),
    );
    if (response) {
      return response;
    }
    return null;
  }

  public async getOnboardedTeams() {
    const response = await this._send<GetOnboardedTeamsCommandOutput>(
      () => new GetOnboardedTeamsCommand(),
    );
    if (response) {
      return response;
    }
    return null;
  }
 
  public async getTeamPackageList(
    teamPackageListInput: GetTeamPackageListCommandInput,
  ) {
    const response = await this._send<GetTeamPackageListCommandOutput>(
      () => new GetTeamPackageListCommand(teamPackageListInput),
    );
    if (response) {
      return response;
    }
    return null;
  }

  public async getPackageDependencyList(
    packageDependencyListInput: GetPackageDependencyListCommandInput,
  ) {
    const response = await this._send<GetPackageDependencyListCommandOutput>(
      () => new GetPackageDependencyListCommand(packageDependencyListInput),
    );
    if (response) {
      return response;
    }
    return null;
  }

  public async submitPackageDryRunUpgrades(packageName: string) {
    const response = await this._send<SubmitPackageDryRunUpgradesCommandOutput>(
      () => new SubmitPackageDryRunUpgradesCommand({ packageName }),
    );
    return response;
  }

  public async getPackageDryRunUpgradesResult(requestId: string) {
    const response = await this._send<GetPackageDryRunUpgradesResultCommandOutput>(
      () => new GetPackageDryRunUpgradesResultCommand({ requestId }),
    );
    return response;
  }
}